/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { Card, Icon } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import {
  DataContextProvider,
  IDataConnectorConfigRaw
} from '@forge/data-connector';
import descriptors from '../../locales/en-US/descriptors';
import {
  ApiContext,
  ContextProvider,
  updateApiConfig
} from '../../context/ApiContext';
import UtilityServiceManageBillComponent from './UtilityServiceManageBillComponent';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { withLocalization } from '../../locales/withLocalization';

interface IManageBillProps {
  integrationType: string;
}
const UtilityServiceManageBillContainer = (props: IAny) => {
  const {
    bearerToken,
    requestContext,
    emaasContext,
    connectorConfig,
    parentPutAxios,
    isManageBill,
    utilityCellData
  } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();

  return (
    <div className="emaas-utility-container-kpi-card-common">
      <Card>
        <Card.Header className="emaas-utility-bill-viewDetails-kpi-header-container">
          <div className="emaas-utility-bill-viewDetails-kpi-card-title">
            <span className="utility-bill-backButton">
              <Icon
                root="common"
                name="arrow-left"
                size="medium"
                onClick={() => emaasContext.setIsManageBill(false)}
              />
            </span>
            {utilityCellData && utilityCellData.providerName}
          </div>
        </Card.Header>
        <Card.Content className="emaas-utility-bill-viewDetails-kpi-content-container">
          <ContextProvider
            value={updateApiConfig({
              connectorConfig,
              ...emaasContext
            })}
          >
            <DataContextProvider config={connectorConfig}>
              <UtilityServiceManageBillComponent
                requestContext={requestContext}
                bearerToken={bearerToken}
                parentPutAxios={parentPutAxios}
                utilityCellData={utilityCellData}
                isManageBill={isManageBill}
              />
            </DataContextProvider>
          </ContextProvider>
        </Card.Content>
      </Card>
    </div>
  );
};

export default withLocalization<IAny>(UtilityServiceManageBillContainer);
